import { API_URL } from "../config";

export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem("token");

  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  if (res.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    window.location.reload();
    return null;
  }

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    console.error(`API error [${options.method || "GET"} ${path}] ${res.status}:`, data);
    throw new Error(data.message || "Ocurrió un error inesperado.");
  }

  return data;
}

// Para endpoints que devuelven un archivo (ej. el acta en PDF) en vez de JSON.
// Abre el archivo en una pestaña nueva.
export async function abrirArchivoProtegido(path) {
  const token = localStorage.getItem("token");
  const res = await fetch(`${API_URL}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.message || "No se pudo generar el archivo.");
  }

  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank");
}
